import React, {useState, useEffect, useRef} from 'react'
import {  Grid, Button, IconButton, Box, Typography, MenuItem, Menu, Avatar, Card, TableCell, Accordion, TableBody, Table, TableContainer, TableHead, TableRow, AccordionSummary, AccordionDetails } from "@mui/material" ;
import { profileSettingStyles, sideNavStyles} from '../../../styles/materialComponent';
import { CssTextField } from '../../../styles/materialComponent';
import {useSelector, useDispatch} from "react-redux"
import {editArborProfile, getProfile} from "../../../actions/arboristLogin"
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import Phone from "../../common/phone"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import DatePicker from "../../common/datePicker"
import {s3} from "../../common/awsS3";
import { NotificationManager } from 'react-notifications';
import SignatureCanvas from 'react-signature-canvas'

// const s3 = new AWS.S3({
//   accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
//   secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
//   region: 'us-east-2',
// })

const uploadImageToS3 = (bucket, key, file) => {
  return new Promise((resolve, reject) => {
    const params = {
      Bucket: bucket,
      Key: key,
      Body: file,
      ContentType: file.type,
    };

    s3.upload(params, (err, data) => {
      if (err) {
        reject(err);
      } else {
        resolve({ url: data.Location, UniqueId: key });
      }
    });
  });
};

const PersonalInformation = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const classes = profileSettingStyles()
    const signRef = useRef(null)
    const [image, setImage] = useState("")
    const { arbor }  = useSelector(({arboristLogin})=>arboristLogin)
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedItemRow, setSelectedRow] = useState(null)
    const [open, setOpen] = useState(false)
    const [edit, setEdit] = useState(false)
    const [idItem, setIdItem] = useState(null)
    const [error, setError] = useState(null)
    const [invalidEmail, setInvalidEmail] = useState(null)
    const [expMonth, setExpMonth]= useState("")
    const [expYear, setExpYear]= useState("")
    const [editAccreditation, setEditAccreditation] = useState(false)
    const [accreditationId, setAccreditationId] = useState(null)

    console.log("signref", signRef.current)
    const [profile, setProfile] = useState({
        firstName:arbor?.firstName ? arbor.firstName : "",
        lastName: arbor?.lastName ? arbor.lastName : "",
        email: arbor?.email ? arbor.email : "",
        profileImage:arbor?.profileImage ? arbor.profileImage :"",
        phone: arbor?.phoneNumber ? arbor?.phoneNumber :"",
        countryCode: arbor?.countryCode ? arbor.countryCode :"",
        experience: arbor?.experience ? arbor?.experience : "",
        projects: arbor?.projectsCompleted ? arbor.projectsCompleted :"",
        bio: arbor?.bio ? arbor?.bio :"",
        address: arbor?.address? arbor.address : "",
        isaNumber:arbor?.isaNumber ? arbor.isaNumber :"",
        linkName : arbor?.linkName ? arbor.linkName : "",
        link: arbor?.link ? arbor.link : "",
        signatureImage: arbor?.signatureImage ? arbor.signatureImage :""
    })

    const currDate = new Date()

    const [links, setLinks] = useState(arbor?.links?.length ? arbor?.links : [])
    const [state, setState] = useState({
      linkName:"",
      link:""
    })

    const [accreditationValues, setAccreditationValues] = useState(arbor?.accreditations?.length ? arbor?.accreditations :[])
    const [accreditation, setAccreditation] = useState({
      accreditation:"",
      accreditationReference:""
    })

    useEffect(()=>{
        dispatch(getProfile())
    },[])

    function isValidEmail(email) {
      return /\S+@\S+\.\S+/.test(email);
    }
    const params = {
      Bucket: 'arborhawkapp',
      Prefix: 'profileImages',
    };

    useEffect(()=>{
      const data = new Date(profile?.experience)
      countExperience(data)
    },[])

    useEffect(()=>{
      s3.listObjectsV2(params, (err, data) => {
        if (err) {
          console.log(err);
          return;
        }
        // log the list of objects in the folder
      });
    },[])

    const handleChange=(e)=>{
        const {name, value} = e.target
        if(name === "email"){
          if(!isValidEmail(e.target.value)){
            setInvalidEmail("email is not valid")
          }else{
            setInvalidEmail("")
          }
        }   
        setProfile({...profile, [name]:value})
    }

    const handleSignClear =()=>{
      signRef.current.clear()
    }

    const handleProfilePic=(e)=>{
      setProfile({...profile, profileImage: ""})

      uploadImageToS3(
        'arborhawkapp/profileImages',
        JSON.stringify(arbor?._id),
        e.target.files[0]
      ) .then((res) => {
        setImage(res.url);
        setProfile({...profile, profileImage: res.url})
      })
      .catch((err) => {
        console.error('Error uploading image:', err);
      })
    }
    const handleSignSave =()=>{
      // const canvas = signRef.current.getTrimmedCanvas().toDataURL()
      setProfile({...profile, signatureImage:""})
     const canvas =  signRef.current.getCanvas()
     canvas.toBlob((blob)=>{
      uploadImageToS3(
        'arborhawkapp/treeImages',
        JSON.stringify(arbor?._id),
        blob
      ) .then((res) => {
        setProfile({...profile, signatureImage: res.url})
        NotificationManager.success("Signature Uploaded successfully")
      })
      .catch((err) => {
        console.error('Error uploading image:', err);
        NotificationManager.error("Error while uploading signature")
      })
     })
    
    }

    const countExperience =(v)=>{
      const today = new Date();
      const getCurrentMonth = today.getMonth()+1
      const getCurrentYear = today.getFullYear()
      const getExperience = new Date(v)
      const getExperienceMonth = getExperience.getMonth()+1
      const getExperienceYear = getExperience.getFullYear()
      let exp;
      let months;
      if(getCurrentYear > getExperienceYear){
        exp = getCurrentYear-getExperienceYear
      }else{
        exp = 0
      }
      
      if(getCurrentMonth >= getExperienceMonth && getCurrentYear >= getExperienceYear){
        months = getCurrentMonth-getExperienceMonth
      }
      else if(getCurrentMonth <= getExperienceMonth && getCurrentYear>getExperienceYear){
        months =12 + getCurrentMonth-getExperienceMonth
      }else{
        months = 0
      }
      setExpYear(`${exp} year ${months} months`)
      // setProfile({...profile, experience: `${exp} year ${months} months`})
    }
    
    const handleDatePicker =(v)=>{
      if(new Date().toISOString().substring(0,10) < v.toISOString().substring(0,10)){
        setError("please select valid date")
      }else{
        setError("")
      }
      countExperience(v)
      // const exp = expYear && expMonth ? `${expYear} Year ${expMonth} Month` : expMonth ? `${expMonth} Month` : expYear ? `${expYear} Year` : null
      setProfile({...profile, experience: v.getTime()})
    }

    const handlePhoneInput = (v, code) => {
      setProfile({...profile, phone:v, countryCode:code})
    };

    const handleLinkChange =(e)=>{
      const {name, value} = e.target
      setState({...state, [name]:value})
    }

    const handleAccreditationChange =(e)=>{
      const {name, value} = e.target
      setAccreditation({...accreditation, [name]:value})
    }

    const handleLinkSave =(e)=>{
      e.preventDefault()
      if(edit){
        setLinks(links?.map((item)=>{
          if(item._id === idItem || item.key === idItem){
            return {...item, linkName: state.linkName, link: state.link}
          }
          return item
        }))
        clear()
        setEdit(false)
      }else{
        const inputData =
        {
          key: new Date().getTime().toString(),
          linkName:state.linkName,
          link: state.link,
        }
        setLinks([...links, inputData])
          clear()
      }
      }

      const handleAccreditationSave =(e)=>{
        e.preventDefault()
        if(editAccreditation){
          setAccreditationValues(
            accreditationValues?.map((item)=>{
              if(item?._id === accreditationId || item.key === accreditationId){
                return {...item, accreditation:accreditation.accreditation, accreditationReference:accreditation.accreditationReference}
              }
              return item
            })
          )
          setEditAccreditation(false)
          setAccreditation({accreditation:"", accreditationReference:""})
        }else{
          const inputData =
          {key: new Date().getTime().toString(), 
            accreditation: accreditation.accreditation,
            accreditationReference:accreditation.accreditationReference
          }
          setAccreditationValues([...accreditationValues, inputData])
          setAccreditation({accreditation:"", accreditationReference:""})
        }
       
      }

    const clear=()=>{
      setState({linkName:"", link:""})
    }

    function handleClick(event, row) {
      setAnchorEl(event.currentTarget);
      setSelectedRow(row)
    }
    function handleCloses() {
      setAnchorEl(null);
      setSelectedRow(null)
    }
    const handleClose = () => {
      setOpen(false);
    };

   
    

    const handleEdit =(row)=>{
      const updateLink = links?.find(link=> {
        return link._id ? link._id === row  : link.key === row
      })
      setState(updateLink)
      setEdit(true)
      setIdItem(row)
      handleCloses()
    }

    const handleAccrediationEdit=(row)=>{
      const updatedItem = accreditationValues.find(item=> {
        return item._id ? item._id === row : item.key === row
      })
      setAccreditation(updatedItem)
      setEditAccreditation(true)
      setAccreditationId(row)
      handleCloses()
    }

    const handleAccrediationDelete=(id)=>{
      const deleteItem = accreditationValues.filter(item=>{
        return item._id ? item._id !== id : item.key !== id
      })
      setAccreditationValues(deleteItem)
    }
    
    const handleDelete =(id)=>{
      const deleteLink = links?.filter((link)=>{
        return link.key ? id!== link.key : id!== link._id
      })
      setLinks(deleteLink)
    }

   

    const handleSubmit =(e)=>{
        e.preventDefault()

        const data={
            firstName:profile.firstName ,
            lastName: profile.lastName ,
            email: profile.email ,
            profileImage:profile.profileImage,
            phoneNumber: profile.phone,
            countryCode: profile.countryCode,
            experience: profile.experience ,
            projectsCompleted: profile.projectsCompleted,
            bio:profile.bio,
            address: profile.address ,
            isaNumber:profile.isaNumber,
            links:links,
            accreditations:accreditationValues,
            signatureImage:profile.signatureImage
        }
        dispatch(editArborProfile(data, navigate))
    }

  return (
      <Card
        sx={{boxShadow: "0 2px 4px 0 rgba(0,0,0,.2)", borderRadius:4, backgroundColor:"#FCFBFD", pt:8, pb:10 }}
      >
       <Box className={classes.profileText}>
      <Typography variant="h4" fontFamily = "CormorantBoldItalic">Profile Information
      </Typography>
    </Box>
        <Grid container spacing={4} className={classes.fields}>
        <Grid item xs={12} sm={12} md={12} lg={12} style={{display:"flex", justifyContent: "center"}}>
        <Box className={classes.avatarView}>

          <Avatar
            sx={{ width: 200, height: 200, my: 4 }}
            src={profile?.profileImage!=="" ? profile.profileImage : profile.profileImage=="" ? "Loading..." : arbor?.profileImage }
          />
          <label htmlFor="select-image" className ={classes.icon}><AddAPhotoIcon sx={{fontSize:40, color:"gray"}} />
          <input
            // accept="image/*"
            type="file"
            name="imageFile"
            id="select-image"
            style={{ display: "none" }}
            onChange={handleProfilePic}
            // onChange={(e)=> uploadImageToS3(
            //   'arborhawkapp/profileImages',
            //   JSON.stringify(arbor?._id),
            //   e.target.files[0]
            // ) .then((res) => {
            //   setImage(res.url);
            //   setProfile({...profile, profileImage: res.url})
            //   console.log("res", res.url)
            // })
            // .catch((err) => {
            //   console.error('Error uploading image:', err);
            // })}
            />
          </label>

        </Box>
            {/* <img src={image ? image : "assets/images/userAv.jpg"} alt="image" height="200" width="200"  /> */}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} style={{display:"flex", justifyContent: "center"}}>

            {/* <label htmlFor="select-image"> */}
              {/* <Button
                variant="contained"
                style={{backgroundColor:"rgb(115 74 153)"}}
                component="span"
              >
                Upload Image
              </Button>              */}
            {/* </label> */}
        </Grid>
       <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          className={classes.textField}
          variant="outlined"
          label="First Name"
          name="firstName"
          value={profile.firstName}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          className={classes.textField}
          variant="outlined"
          label="Last Name"
          name="lastName"
          value={profile.lastName}
          onChange={handleChange}
        />
      </Grid>
       <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          className={classes.textField}
          variant="outlined"
          label="Email"
          name="email"
          value={profile.email}
          onChange={handleChange}
        />
      </Grid>
      {invalidEmail? <div style={{color:"red"}}>{invalidEmail}</div>: null}

      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid} >
        <CssTextField
          className={classes.textField}
          variant="outlined"
          multiline
          rows={4}
          label="Bio"
          name="bio"
          value={profile.bio}
          onChange={handleChange} />
      </Grid>
       <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid} >
        <CssTextField
          className={classes.textField}
          variant="outlined"
          label="Address"
          name="address"
          value={profile.address}
          onChange={handleChange} />
      </Grid>
       <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
       <Phone
          required
          variant="outlined"
          label="Phone No"
          name="phone"
          value={JSON.stringify(profile.phone)}
          onChange={(v, code) => handlePhoneInput(v, code)}
          // // onChange={(e)=>handleContactChange(e, index, "phone")}
          />
      </Grid>
       <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid} >
        <DatePicker
          name="experience"         
          label="experience"
          variant="outlined"
          onChange={(e)=> handleDatePicker(e)}
          value={expYear}       
        />
        {/* <CssTextField
          className={classes.textField}
          variant="outlined"
          label="Experience"
          name="experience"
          value={profile.experience}
          onChange={handleChange}
        /> */}
      </Grid>
      {error? <Typography align="left"style={{color:"red"}}>{error}</Typography>: null}
       <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          className={classes.textField}
          variant="outlined"
          name="projects"
          label="Projects completed"
          value={profile.projects}
          onChange={handleChange}
        />
      </Grid>
       <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          className={classes.textField}
          variant="outlined"
          label="ISA Number"
          name="isaNumber"
          value={profile.isaNumber}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12}  className={classes.grid}>

      <Accordion className={classes.textField} style={{ backgroundColor:"#FCFBFD"}}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls= "panel1a-content"
        id="panel1a-header"
      >
      <Typography style={{color:"rgba(0, 0, 0, 0.6)"}}>Add Signature</Typography>
    </AccordionSummary>
    <AccordionDetails>
    <Grid container spacing={3} style={{padding:10}}> 
      <Grid item xs={12} sm={12} md={12} lg={12} className = {classes.grid}>       
        <SignatureCanvas
          // penColor='green'
          ref={signRef}
          canvasProps={{className:classes.signCanvas}}
        />
        {/* <CssTextField
          className={classes.textField}
          variant="outlined"
          label="Signature"
          name="signature"
          value={profile.signature}
          onChange={handleChange}
        /> */}
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}> 
      {profile?.signatureImage!=="" ? 
        <img src={profile?.signatureImage} alt="sign" width="350" height="150"/> :
        profile?.signatureImage=="" ?<div>Loading...</div>:
       <img src={arbor?.signatureImage} alt="sign" width="350" height="150"/>}
         
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}> 
      <Button
        className={classes.submitButton}
        // fullWidth
        style={{ backgroundColor:signRef?.current&& "rgb(115 74 153)", color:"#fff"}}
        size="large"
        variant="contained"
        onClick={handleSignSave}
        disabled={signRef?.current  ? false : true }
      >
        Save
      </Button>
      <Button
        // type="reset"
        className={classes.cancelButton}
        style={{backgroundColor:"lightgray", color:"black"}}
        size="large"
        variant="contained"
        onClick={handleSignClear}
      >
        Clear
      </Button>
      </Grid>    
   

  </Grid>
  </AccordionDetails>
</Accordion>
      </Grid>

<Grid item xs={12} sm={12} md={12} lg={12}  className={classes.grid}>

<Accordion className={classes.textField} style={{ backgroundColor:"#FCFBFD"}}>
  <AccordionSummary
    expandIcon={<ExpandMoreIcon />}
    aria-controls= "panel1a-content"
    id="panel1a-header"
  >
    <Typography style={{color:"rgba(0, 0, 0, 0.6)"}}>Accreditation</Typography>
  </AccordionSummary>
  <AccordionDetails>
  <Grid container spacing={3} style={{padding:10}}>
  <TableContainer>
  <Table aria-label="simple table">
  <TableHead>
    <TableRow>
      <TableCell>Accreditation</TableCell>
      <TableCell>Accreditation Reference</TableCell>
      <TableCell>Actions</TableCell>

      </TableRow>
      </TableHead>
      <TableBody>
      {
       accreditationValues?.length ? accreditationValues?.map((row)=>
        <TableRow>
          <TableCell>{row?.accreditation}</TableCell>
          <TableCell>{row?.accreditationReference}</TableCell>
          <TableCell>
          <Box>
            <IconButton
              aria-label="More"
              aria-owns={open ? "long-menu" : undefined}
              aria-haspopup="true"
              onClick={(event)=>handleClick(event, row)}
              style={{backgroundColor:"gray", color:"white", borderRadius:"4px", padding:7}}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              open={Boolean(anchorEl && selectedItemRow === row)}
              id="long-menu"
              anchorEl={anchorEl}
              onClose={handleCloses}
            >
                <MenuItem onClick={handleClose} >
                <IconButton onClick={()=>handleAccrediationEdit(row.key?row.key:row._id)}>
                <EditIcon /><Typography style={{marginLeft:5}}>Edit</Typography>
                </IconButton>
                </MenuItem>
                <MenuItem onClick={handleClose} >
                <IconButton onClick={()=>handleAccrediationDelete(row.key? row.key: row._id)}>
                <DeleteIcon /><Typography style={{marginLeft:5}}>Delete</Typography>
                  </IconButton>
                </MenuItem>

            </Menu>
        </Box>
          </TableCell>
        </TableRow>
        ):null
      }
      </TableBody>
      </Table>
  </TableContainer>
   <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
  <CssTextField
    className={classes.textField}
    style={{width:"100%"}}
    variant="outlined"
    name="accreditation"
    label="Accreditation"
    value={accreditation.accreditation}
    onChange={handleAccreditationChange}
  />
</Grid>
<Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
  <CssTextField
    style={{width:"100%"}}
    className={classes.textField}
    variant="outlined"
    name="accreditationReference"
    label="Accreditation Reference"
    value={accreditation.accreditationReference}
    onChange={handleAccreditationChange}
  />
</Grid>
<Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
  <Button
    className={classes.submitButton}
    // fullWidth
    style={{ backgroundColor:(accreditation.accreditation && accreditation.accreditationReference) && "rgb(115 74 153)", color:"#fff"}}
    size="large"
    variant="contained"
    onClick={handleAccreditationSave}
    disabled={accreditation.accreditation && accreditation.accreditationReference ? false : true }
  >
    Save
  </Button>
  <Button
    type="reset"
    className={classes.cancelButton}
    style={{backgroundColor:"lightgray", color:"black"}}
    size="large"
    variant="contained"
  >
    Cancel
  </Button>
  </Grid>
  </Grid>
  </AccordionDetails>
</Accordion>
</Grid>
      <Grid item xs={12} sm={12} md={12} lg={12}  className={classes.grid}>

      <Accordion className={classes.textField} style={{ backgroundColor:"#FCFBFD"}}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls= "panel1a-content"
          id="panel1a-header"
        >
          <Typography style={{color:"rgba(0, 0, 0, 0.6)"}}>Links</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <Grid container spacing={3} style={{padding:10}}>
        <TableContainer>
        <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Link Name</TableCell>
            <TableCell>Link</TableCell>
            <TableCell>Actions</TableCell>

            </TableRow>
            </TableHead>
            <TableBody>
            {
             links?.length && links?.map((row)=>
              <TableRow>
                <TableCell>{row?.linkName}</TableCell>
                <TableCell>{row?.link}</TableCell>
                <TableCell>
                <Box>
                  <IconButton
                    aria-label="More"
                    aria-owns={open ? "long-menu" : undefined}
                    aria-haspopup="true"
                    onClick={(event)=>handleClick(event, row)}
                    style={{backgroundColor:"gray", color:"white", borderRadius:"4px", padding:7}}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    open={Boolean(anchorEl && selectedItemRow === row)}
                    id="long-menu"
                    anchorEl={anchorEl}
                    onClose={handleCloses}
                  >
                      <MenuItem onClick={handleClose} >
                      <IconButton onClick={()=>handleEdit(row.key?row.key:row._id)}>
                      <EditIcon /><Typography style={{marginLeft:5}}>Edit</Typography>
                      </IconButton>
                      </MenuItem>
                      <MenuItem onClick={handleClose} >
                      <IconButton onClick={()=>handleDelete(row.key? row.key: row._id)}>
                      <DeleteIcon /><Typography style={{marginLeft:5}}>Delete</Typography>
                        </IconButton>
                      </MenuItem>

                  </Menu>
              </Box>
                </TableCell>

              </TableRow>
              )
            }
            </TableBody>
            </Table>
        </TableContainer>
         <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          className={classes.textField}
          style={{width:"100%"}}
          variant="outlined"
          name="linkName"
          label="Link Name"
          value={state.linkName}
          onChange={handleLinkChange}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          style={{width:"100%"}}
          className={classes.textField}
          variant="outlined"
          name="link"
          label="Link"
          value={state.link}
          onChange={handleLinkChange}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <Button
          className={classes.submitButton}
          // fullWidth
          style={{ backgroundColor:(state.linkName && state.link) && "rgb(115 74 153)", color:"#fff"}}
          size="large"
          variant="contained"
          onClick={handleLinkSave}
          disabled={state.linkName && state.link ? false : true }
        >
          Save
        </Button>
        <Button
          type="reset"
          className={classes.cancelButton}
          style={{backgroundColor:"lightgray", color:"black"}}
          size="large"
          variant="contained"
        >
          Cancel
        </Button>
        </Grid>
        </Grid>
        </AccordionDetails>
      </Accordion>
      </Grid>

       <Grid item xs={12} sm={12} md={6} lg={6} className={classes.grid}>
        <Button
          className={classes.submitButton}
          style={{backgroundColor: (!error && !invalidEmail) &&  "rgb(115 74 153)", color:"#fff"}}
          size="large"
          variant="contained"
          disabled={invalidEmail || error ? true : false}
          onClick={handleSubmit}
        >
          Update
        </Button>
        <Button
          type="reset"
          className={classes.cancelButton}
          style={{backgroundColor:"lightgray", color:"black"}}
          size="large"
          variant="contained"
        >
          Cancel
        </Button>
      </Grid>
      {/* </Grid>
          // </Card>
          </Grid> */}
    </Grid>
    </Card>
  )
}

export default PersonalInformation